import React from 'react';
import { Edit, SimpleForm, TextInput } from 'react-admin';
import RequiredInput from 'resources/qualifications/RequiredInput';

const QualificationAttributeEdit = () => {
  return (
    <Edit mutationMode="pessimistic" data-testid="staff-edit" redirect="show">
      <SimpleForm>
        <TextInput source="name" fullWidth multiline />
        <RequiredInput action="update" />
      </SimpleForm>
    </Edit>
  );
};

export default QualificationAttributeEdit;
